export default __webpack_public_path__ + "static/media/chart-no-data-eng.057df1c4.svg";